var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 9.6H2.4C2.0287 9.6 1.6726 9.4525 1.41005 9.18995C1.1475 8.9274 1 8.5713 1 8.2V1.9C1 1.5287 1.1475 1.1726 1.41005 0.91005C1.6726 0.6475 2.0287 0.5 2.4 0.5H8.7C9.0713 0.5 9.4274 0.6475 9.68995 0.91005C9.9525 1.1726 10.1 1.5287 10.1 1.9V2.6M7.3 5.4H13.6C14.3732 5.4 15 6.0268 15 6.8V13.1C15 13.8732 14.3732 14.5 13.6 14.5H7.3C6.5268 14.5 5.9 13.8732 5.9 13.1V6.8C5.9 6.0268 6.5268 5.4 7.3 5.4Z",
    stroke: "url(#paint0_linear)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1,
    y1: 7.37277,
    x2: 15,
    y2: 7.37277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC762A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.11732de09e26353647a4345829fff6de.svg";
export { ForwardRef as ReactComponent };